import React, { lazy, Suspense } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../../accessmanagment/page-action/AccessPageAction";
import { commonText, reyPaymentLogs } from "../../../locales/en";
import ErrorBoundary from "../../../components/error-boundary";
import ComponentViewFallback from "../../../components/error-boundary/fallback/ComponentViewFallback";

const RepaymentsLogsTable = lazy(
  () =>
    import(
      "../../../components/table/all-tables/logstable/all-logs/RepaymentsLogsTable"
    )
);

const Repaymentslogs = () => {
  return (
    <>
      <TablePagesTitle
        mainTitle={reyPaymentLogs.mainTitle}
        content={reyPaymentLogs.content}
      />
      <AccessPageAction subheading={reyPaymentLogs.subheading} />
      <ErrorBoundary fallback={<ComponentViewFallback />}>
        <div className="row mb-3 mx-0">
          <div className="col-12">
            <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
              <RepaymentsLogsTable />
            </Suspense>
          </div>
        </div>
      </ErrorBoundary>
    </>
  );
};

export default Repaymentslogs;
